import OurIconButton from './OurIconButton';
import OurSendMailIcon from '../icons/OurSendMailIcon';

const OurSendMailButton = () => <OurIconButton tip="Send" Icon={OurSendMailIcon} type="submit" />;

export default OurSendMailButton;
